export const STAGE_TYPES = {
  roughIn: 1,
  topOut: 2,
  trim: 3,
  boxAndWrap: 5,
};
